import {Component, HostListener, Inject, ViewChild} from "@angular/core"
import {MAT_SNACK_BAR_DATA} from "@angular/material/snack-bar"
import {SnackbarService} from "src/app/_services/shared/snackbar.service"

@Component({
    selector: "wfdss-api-error",
    templateUrl: "./api-error.component.html",
    styleUrls: ["./api-error.component.scss"],
    standalone: false
})
export class ApiErrorComponent {
	constructor(@Inject(MAT_SNACK_BAR_DATA) public errorArray: {[key: string]: {errorMessage: string; statusCode: string}[]}, private sbs: SnackbarService) {}
	@ViewChild("errorComponentParentElement") errorParentElement
	@HostListener("document:click", ["$event.target"])
  /**
   * @description Checks click origin. If origin is not within snackbar, close the snackbar.
   */
	public onClickCheckForClickout(clickTarget) {
		const clickIsInsideParent = this.errorParentElement.nativeElement.contains(clickTarget)
		if (!clickIsInsideParent) {
			this.sbs.closeErrorSnackbar()
		}
	}
	@HostListener("window:keydown.escape", ["$event"])
	onKeyboardEscape() {
		this.sbs.closeErrorSnackbar()
	}
	onClickDismiss() {
		this.sbs.closeErrorSnackbar()
	}
}
